export default __webpack_public_path__ + "static/media/rug6-min.ee4c133e.jpg";